import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Collapse,
  Divider,
  Grid,
} from "@mui/material";
import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { toast } from "react-toastify";

import DefaultApiService from "../../../../../infrastructure/api/default";
import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import ReportDataShow from "../../../../components/shared/report/ReportDataShow";
import Selector from "../../../../components/shared/selector";
import { filterArrayByArrayId } from "../../../../middleware/middleware";

const ComprehensiveReportPage = () => {
  const pageInfo = useGetPageInfo();
  const dataList = useLoaderData("root");

  const [state, setState] = useState({
    cityList: Object.assign(dataList?.cityList),
    substationList: [],
    feederList: [],
    gridData: [],
    loading: false,
    table: [],
  });
  const [filterValues, setFilterValues] = useState({
    CityIdList: [],
    SubstationIdList: [],
    FeederIdList: [],
    LevelKind: "City",
  });
  const [showFilterContainer, setShowFilterContainer] = useState(true);
  const [tableData, setTableData] = useState({
    columns: [],
    data: [],
  });
  const [chartData, setChartData] = useState({
    data: [],
  });

  const onChangeLevelKind = (event) => {
    const value = event.target.value;
    setFilterValues((old) => ({
      ...old,
      LevelKind: value,
      CityIdList: [],
      SubstationIdList: [],
      FeederIdList: [],
    }));

    let substationList = [];
    if (value === "Substation") {
      substationList = dataList?.substationList;
    }

    setState((old) => ({
      ...old,
      cityList: dataList.cityList.map((old) => ({ ...old, isChecked: false })),
      substationList,
      feederList: [],
    }));
  };

  const onChangeCity = (checked) => {
    setFilterValues((old) => ({
      ...old,
      CityIdList: checked,
    }));

    setState((old) => ({
      ...old,
      substationList: filterArrayByArrayId({
        list: dataList?.substationList,
        key: "cityId",
        ids: checked,
      }),
    }));

    onChangeSubstation([]);
  };

  const onChangeSubstation = (checked) => {
    setFilterValues((old) => ({
      ...old,
      SubstationIdList: checked,
      FeederIdList: [],
    }));

    setState((old) => ({
      ...old,
      feederList: filterArrayByArrayId({
        list: dataList?.feederCounterPositionList,
        key: "substationId",
        ids: checked,
      }),
    }));
  };

  const onClearFilterValues = () => {
    setFilterValues(() => ({
      CityIdList: [],
      SubstationIdList: [],
      FeederIdList: [],
      LevelKind: "City",
    }));

    setState((old) => ({
      ...old,
      cityList: dataList.cityList.map((old) => ({ ...old, isChecked: false })),
      substationList: [],
      feederList: [],
    }));
  };

  const onGetReportData = async () => {
    console.log("filterValues", filterValues);
    try {
      setState((old) => ({ ...old, loading: true }));

      const res = await DefaultApiService.postApi(
        "DG/Management/ComprehensiveReport/GetData",
        filterValues
      );

      setState((old) => ({ ...old, loading: false }));
      // Make Table Data
      if (res?.data?.tableData) {
        const table = res?.data?.tableData;

        const tableColumns = table.columns.map((x) => ({
          id: x,
          label: x,
        }));
        const tableData = table.data.map((row, index) => {
          let item = {};

          for (let i = 0; i < row.length; i++) {
            item[table.columns[i]] = row[i];
          }
          return item;
        });

        setTableData((old) => ({
          ...old,
          columns: tableColumns,
          data: tableData,
          title: table?.title,
        }));
      }

      // Make Chart Data
      if (res?.data?.chartData) {
        const chart = res?.data?.chartData;
        let finalChartData = [];

        finalChartData = chart.xValues.map((item, index) => ({
          x: item,
          index: index + 1,
        }));

        for (let i = 0; i < chart.data.length; i++) {
          const yData = chart.data[i];
          const sereTitle = chart.seriesTitle[i];

          for (let j = 0; j < yData.length; j++) {
            finalChartData[j][sereTitle] = yData[j];
          }
        }

        // console.log("finalChartData", finalChartData);

        setChartData({
          ...chart,
          data: finalChartData,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
      setState((old) => ({ ...old, loading: false }));
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title="گزارش جامع درخواست ها"
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Button
                  variant="outlined"
                  color="warning"
                  startIcon={<SearchIcon />}
                  onClick={onGetReportData}
                  disabled={state.loading}
                >
                  جستجو
                  {state.loading && (
                    <CircularProgress
                      color="warning"
                      size={16}
                      sx={{ ml: 2 }}
                    />
                  )}
                </Button>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />
                <Button
                  variant="text"
                  color="gray"
                  startIcon={<HighlightOffIcon />}
                  onClick={onClearFilterValues}
                >
                  حذف فیلترها
                </Button>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<CandlestickChartIcon />}
                  onClick={() => {
                    setShowFilterContainer(!showFilterContainer);
                  }}
                >
                  {showFilterContainer ? "پنهان کردن فیلتر" : "نشان دادن فیلتر"}
                </Button>
              </Box>
            }
          />
          <CardContent>
            <Grid container>
              {/* Filter Section */}
              <Grid container item xs={12} md={12} className="filter-bar">
                <Grid item container xs={12} md={12} spacing={2}>
                  {/* <Grid item xs={12} md={2} lg={2}>
                    <DropdownPicker
                      label="به تفکیک"
                      value={filterValues.LevelKind}
                      onChange={onChangeLevelKind}
                      list={dataList.levelKind}
                      size="small"
                    />
                  </Grid> */}
                </Grid>
              </Grid>
              <Collapse
                in={showFilterContainer}
                timeout="auto"
                unmountOnExit
                sx={{ width: "100%" }}
              >
                <Grid container>
                  {/* City */}
                  {filterValues.LevelKind !== "Substation" && (
                    <Grid item xs={12} md={6} lg={2}>
                      <Selector
                        title="همه شهرستان‌ها"
                        options={state.cityList}
                        optionName="cityName"
                        optionValue="id"
                        selectedValues={filterValues.CityIdList}
                        onChange={onChangeCity}
                      />
                    </Grid>
                  )}
                  {/* Substation */}
                  <Grid item xs={12} md={6} lg={2}>
                    <Selector
                      title="همه ایستگاه‌ها"
                      options={state.substationList}
                      optionName="substationName"
                      optionValue="id"
                      selectedValues={filterValues.SubstationIdList}
                      onChange={onChangeSubstation}
                    />
                  </Grid>

                  {/* Feeder */}
                  {/* {filterValues.LevelKind !== "Substation" && ( */}
                  <Grid item xs={12} md={6} lg={2}>
                    <Selector
                      title="همه فیدرها"
                      options={state.feederList}
                      optionName="positionName"
                      optionValue="id"
                      selectedValues={filterValues.FeederIdList}
                      onChange={(checked) => {
                        setFilterValues((old) => ({
                          ...old,
                          FeederIdList: checked,
                        }));
                      }}
                    />
                  </Grid>
                </Grid>
              </Collapse>

              {/* Data */}
              <ReportDataShow
                tableData={tableData}
                chartData={chartData}
                loading={state.loading}
                hasExportPdf={useCheckPermission("pdf")}
                hasExportExcel={useCheckPermission("excel")}
                exportApi={pageInfo.link}
                filterValues={filterValues}
              />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ComprehensiveReportPage;
